/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './styles.module.scss';

const HeaderShared = ({ className = null, children = null, ...props }) => (
  <header {...props} className={cx(s.header, className)}>
    {children}
  </header>
);

HeaderShared.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default HeaderShared;
